import { ConsentType } from 'models/newsletter'

export const newsletterTokenList: Record<ConsentType, string> = {
  default: '5',
  currencyComments: 'E',
  forTests: '4',
  cardTestsWithOpinions: 'P',
  cardTestsWithoutOpinions: 'Z',
}
